import { QueryDto } from '@routellers/types/dist/shared/query.dto';
import { QueryRO } from '@routellers/types/dist/shared/query.ro';
import { MissingTranslationRO } from '@routellers/types/dist/translation/missing-transaction.ro';

import { ApiMethodDeclaration } from '..';

type ParamsData = QueryDto;

type ResponseData = QueryRO<MissingTranslationRO>;

export const queryMissing: ApiMethodDeclaration<ParamsData, ResponseData> = (params) => ({
    url: '/missing-translations',
    method: 'GET',
    params,
});
